import { render, staticRenderFns } from "./left-table.vue?vue&type=template&id=cd293046&scoped=true"
import script from "./left-table.vue?vue&type=script&lang=js"
export * from "./left-table.vue?vue&type=script&lang=js"
import style0 from "./left-table.vue?vue&type=style&index=0&id=cd293046&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd293046",
  null
  
)

export default component.exports